import {ComponentPropsWithoutRef, forwardRef} from 'react';
import {Body} from './index.styled';

export const DrawerBody = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>((props, forwardedRef) => (
	<Body {...props} ref={forwardedRef} />
));
